import { IMAGE_BUCKET_URL,IMGBUCKETURL } from "../../DataStore/ApiConstant";
import { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { connect } from "react-redux";
import TranslatesContent from "../../DataStore/Languages/translatesContent";
import { useRef } from "react";
import { useEffect } from "react";
import { fetchLoyaltyUser } from "../../DataStore/LoyaltyUser/LoyaltyUserActions";

const FeaturedGames = ({
  login,
  openPopup,
  cashier = "false",
  setSelectedGameType,
  openGeneralModal,
  siteImages,
  loyaltyUser,
  fetchLoyaltyUserData,
}) => {
  const history = useHistory();
  const gameWrapperArea = useRef(null);

  const featuredGameClicked = (type) => {
    if(cashier === "true"){
      history.push("/lobby")
      gameWrapperArea.current?.scrollIntoView({ behavior: "smooth" });
      setSelectedGameType(type)
    }else{
      gameWrapperArea.current?.scrollIntoView({ behavior: "smooth" });
      setSelectedGameType(type)
    }
    // cashier === "true" ? history.push("/lobby") : setSelectedGameType(type);
  };
    useEffect(() => {
    if (login && !loyaltyUser) {
      fetchLoyaltyUserData();
    }
  }, [login, loyaltyUser, fetchLoyaltyUserData]);

    const rawLoyaltyPayload = loyaltyUser?.data?.data ?? loyaltyUser?.data ?? loyaltyUser;
    const loyaltyTierData = Array.isArray(rawLoyaltyPayload)
      ? (rawLoyaltyPayload[0] || {})
      : (rawLoyaltyPayload || {});

    const currentTierName = loyaltyTierData?.category_name || "Bronze";
    const logoValue = loyaltyTierData?.logo || "1.png";
    const currentTierLogo = /^https?:\/\//i.test(logoValue)
      ? logoValue
      : `${IMAGE_BUCKET_URL}${logoValue}`;

  return (
    <div className="container-fluid mt-lg-1 mt-1">
      <div className="d-flex justify-content-center">

        <div
          className="col zoom"
          onClick={() => featuredGameClicked("liveCasino")}
        >
          <div className="row" data-aos="fade-up" data-aos-duration="3000">
            <div className="col position-relative">
              {siteImages && Object.keys(siteImages?.images).length > 0 && <>
                <img
                src={IMGBUCKETURL + siteImages?.images?.main_tile_live_casino[0] || "default.png"}
                // src={IMGBUCKETURL + "Live_casino_local2.png"}
                className="img-fluid mx-auto d-block"
                alt="..."
              />
              </>}

            </div>
            <p className="catTitel mt-0">
              <TranslatesContent contentKey="live-casino" />
            </p>
          </div>
        </div>
        <div
          className="col zoom"
          onClick={() => featuredGameClicked("events")}
          // onClick={() => alert("This is not reachable")}

        >
          <div className="row" data-aos="fade-up" data-aos-duration="3000">
            <div className="col position-relative">
            {siteImages && Object.keys(siteImages?.images).length > 0 && <>
                <img
                src={IMGBUCKETURL + siteImages?.images?.main_tile_sports[0] || "default.png"}
                // src={IMGBUCKETURL + "Casino_event_local2.png"}
                className="img-fluid mx-auto d-block"
                alt="..."
              />
              </>}
            </div>
            <p className="catTitel mt-0">
              {/* <TranslatesContent contentKey="events" /> */}
              EVENTS
            </p>
          </div>
        </div>

        <div
          className="col zoom"
          onClick={() => featuredGameClicked("promotions")}
        >
          <div className="row" data-aos="fade-up" data-aos-duration="3000">
            <div className="col position-relative" style={{ overflow: "visible" }}>
            {siteImages && Object.keys(siteImages?.images).length > 0 && <>
                <img
                // src={IMGBUCKETURL + "Promotion_local2.png"}
                src={IMGBUCKETURL + siteImages?.images?.main_tile_promotion[0] || "default.png"}
                className="img-fluid mx-auto d-block"
                alt="..."
              />
              </>}
            </div>
            <p className="catTitel mt-0">
              <TranslatesContent contentKey="promotions" />
            </p>
          </div>
        </div>
        <div
          className="col zoom"
           onClick={(e) => {
            e.preventDefault();
            if (login) {
              featuredGameClicked("loyalty");
              return;
            }

            localStorage.setItem("pendingGameArea", "loyalty");
            openPopup("login");
          }}
          // onClick={() => alert("This is not reachable")}
        >
          <div className="row" data-aos="fade-up" data-aos-duration="3000">
            <div className="col position-relative" style={{ overflow: "visible" }}>
            {siteImages && Object.keys(siteImages?.images).length > 0 && <>
                <img
                src={IMGBUCKETURL + siteImages?.images?.main_tile_slots[0] || "default.png"}
                // src={IMGBUCKETURL + "LoyaltyLocal2.png"}

                className="img-fluid mx-auto d-block"
                alt="..."
              />
              </>}
              <div
                className="loyaltyBadge"
                style={{
                  zIndex: 10,
                  opacity: 1,
                  visibility: "visible",
                  display: "block",
                  pointerEvents: "none",
                  top: "6%",
                  left: "4%",
                  width: "72px",
                  height: "72px"
                }}
              >
                {login && (
                  <div className="shiny-box">
                    <img src={currentTierLogo} className="img-fluid" alt={currentTierName} />
                    <div className="shine-effect" />
                  </div>
                )}
              </div>
            </div>
            <p className="catTitel mt-0">
              {/* <TranslatesContent contentKey="loyalty" /> */}
              LOYALTY
            </p>
          </div>
        </div>
      </div>
      <div style={{scrollmargin: "400px"}} ref={gameWrapperArea}></div>
    </div>
  );
};

const setStatetoProps = (state) => {
  return {
    LanguageContent: state.SiteLanguages,
    siteImages : state.siteImages,
    loyaltyUser: state.LoyaltyUser?.data || null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLoyaltyUserData: () => dispatch(fetchLoyaltyUser()),
  };
};

// const BindStateToProps = (state=>{
//   return {
//       siteImages : state.siteImages
//       LanguageContent: state.SiteLanguages,
//   }
// })
export default connect(setStatetoProps, mapDispatchToProps)(FeaturedGames);

// export default FeaturedGames;
